<template>
	<div class="EditReportComment">
		<!-- Comment header -->
		<div id="comment-header" class="Page-section Page-section--primaryLight">
			<div class="Page-section-inner Page-section-inner--md">
				<CloHeading level="2">{{ comment === '' ? $t('tripReport.commentAdd') : $t('tripReport.commentEdit') }}</CloHeading>
				<p class="u-margin-none">
					{{ $t('tripReport.commentEditDesc') }}
				</p>
			</div>
		</div>
		<!-- Comment content -->
		<div id="comment-content" class="Page-section">
			<div class="Page-section-inner Page-section-inner--md">
				<form>
					<CloInputTextarea id="inputId" name="comment" :maxlength="8000" @input="commentTextEntered" v-model="comment" />
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import CloHeading from '@/base/CloHeading/CloHeading.vue';
import CloGridAuto from '@/grid/CloGridAuto/CloGridAuto.vue';
import CloInputTextarea from '@/forms/CloInputTextarea/CloInputTextarea.vue';
export default {
	name: 'EditReportComment',
	components: {
		CloHeading,
		CloGridAuto,
		CloInputTextarea,
	},
	data() {
		return {
			baseUrl: window.baseUrl,
			tripApiBaseUrl: window.tripApiBaseUrl,
			tripManageApiBaseUrl: window.tripManageApiBaseUrl,
			currentUserId: window.userId,
			tripReportModelData: window.tripReport ? window.tripReport : '',
			csrf: window['_csrf'],
			csrf_header: window['_csrf_header'],
			dataHasChanged: false,
			currentPerson: {},
			comment: '',
		};
	},
	props: {
		reportId: {
			type: Number,
			required: true,
		},
		locale: String,
	},
	mounted() {},
	created() {
		this.setCurrentPerson();
		this.getCurrentPersonComment();
	},
	computed: {},
	methods: {
		setCurrentPerson() {
			let userId = this.currentUserId;
			let person = this.tripReportModelData.people.filter(function (e) {
				return e.userId === userId;
			});
			this.currentPerson = person[0];
		},
		setDataHasChanged() {
			this.dataHasChanged = true;
		},
		getCurrentPersonComment() {
			let personId = this.currentPerson.tripReportPersonId;
			let url = `${this.tripApiBaseUrl}comments/${this.reportId}`;
			axios
				.get(url)
				.then((res) => {
					// api returns null if no comments
					if (res.data) {
						// set the comment to the comment or empty string
						let comments = res.data;
						let currentPersonComment = {};
						var result = comments.filter((obj) => {
							return obj.tripReportPersonId === personId;
						});
						if (result && result.length > 0) {
							currentPersonComment = result[0];
						}
						this.comment = currentPersonComment.comment.replace(/<br\/\>/gi, '\n');
					}
				})
				.catch((err) => {
					console.log('failed', err);
				});
		},
		saveComment() {
			if (this.dataHasChanged) {
				let url = `${this.tripManageApiBaseUrl}update-comment/${this.reportId}`;
				let formData = new FormData();
				formData.append('comment', this.comment);
				let headers = {};
				headers[this.csrf_header] = this.csrf;
				axios
					.post(url, formData, {
						headers: headers,
						withCredentials: true,
					})
					.then((res) => {
						window.location = baseUrl + 'tripreport/' + this.reportId;
					})
					.catch((err) => {
						console.log(err);
					});
			} else {
				window.location = baseUrl + 'tripreport/' + this.reportId;
			}
		},
		commentTextEntered() {
			this.setDataHasChanged();
		},
	},
};
</script>

<style lang="scss">
.EditReportComment {
	height: 100%;
	display: flex;
	flex-direction: column;
	#comment-content {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
	}
	.Page-section-inner {
		flex-grow: 1;
		width: 100%;
	}
	form,
	.InputTextarea,
	.InputTextarea-field {
		height: 100%;
		width: 100%;
	}
	.InputTextarea-field {
		resize: none;
		@include inset-md;
	}
}
</style>
